/*
Adjustable Shelves
*/
const name = 'Adjustable Shelves'
const id = 'pLwcZ2rXLJdGRAyi2VNr'

export default {
  name,
  id
}
